module.exports = __webpack_public_path__ + "static/media/photo1.d7f92ebd.jpg";